import { Injectable } from '@angular/core';
import { VariableEditorPermissionLevel } from '@selfai-platform/pipeline-common';
import { PermissionService, PipelinePermission } from '@selfai-platform/shared';
import { Observable, of } from 'rxjs';

@Injectable()
export class GlobalVariablesPermissionService {
  constructor(private readonly permissionService: PermissionService) {}

  public getUserPermissions(): Observable<VariableEditorPermissionLevel[]> {
    const permissions: VariableEditorPermissionLevel[] = [];

    if (this.canListGlobalVariables()) {
      permissions.push(VariableEditorPermissionLevel.READ);
    }

    if (this.canCreateGlobalVariables()) {
      permissions.push(VariableEditorPermissionLevel.CREATE);
    }

    if (this.canUpdateGlobalVariables()) {
      permissions.push(VariableEditorPermissionLevel.UPDATE);
    } else if (this.canUpdateGlobalVariablesValue()) {
      permissions.push(VariableEditorPermissionLevel.UPDATE_VALUE_ONLY);
    }

    if (this.canDeleteGlobalVariables()) {
      permissions.push(VariableEditorPermissionLevel.DELETE);
    }

    return of(permissions);
  }

  private canListGlobalVariables(): boolean {
    return this.hasPermission(PipelinePermission.GlobalVariablesList);
  }

  private canCreateGlobalVariables(): boolean {
    return this.hasPermission(PipelinePermission.GlobalVariablesCreate);
  }

  private canUpdateGlobalVariables(): boolean {
    return this.hasPermission(PipelinePermission.GlobalVariablesUpdate);
  }

  private canUpdateGlobalVariablesValue(): boolean {
    return this.hasPermission(PipelinePermission.GlobalVariablesUpdateValue);
  }

  private canDeleteGlobalVariables(): boolean {
    return this.hasPermission(PipelinePermission.GlobalVariablesDelete);
  }

  private hasPermission(permission: PipelinePermission): boolean {
    return this.permissionService.getPipelinePermissions().includes(permission);
  }
}
